// extracted by mini-css-extract-plugin
export default {"footnote":"Charts_footnote__SWrXO"};